/**
 * src/main.ts
 */
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app.module";

// Simples e direto. O ambiente já deve estar pronto via index.html
const startApp = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if ("serviceWorker" in navigator && !isSafari) {
    navigator.serviceWorker
      .register("/pwa-maxisite/service-worker.js")
      .catch(err => console.error("SW Error", err));
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error("Bootstrap Error", err));
};

startApp();


// WEBPACK FOOTER //
// ./src/app/main.ts